import nBossConnection from 'modules/base/service/nBossConnection';
import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import IsolationForestModelEditDto from '../dto/IsolationForestModelEditDto';

class IsolationForestModelEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'isolationForestModelEditControl';
	}

	/**
	 * @return {Promise<IsolationForestModelEditDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new IsolationForestModelEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {string} type
	 * @return {Promise<IsolationForestModelEditDto>}
	 */
	createByType(type) {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response =>
					resolve(
						new IsolationForestModelEditDto().setup({
							...response.data,
							type
						})
					)
				)
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<IsolationForestModelEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new IsolationForestModelEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {IsolationForestModelEditDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {IsolationForestModelEditDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new IsolationForestModelEditService();
